<section class="mt-4">

  @defer (when !isLoading()) {
  @if (products().length) {
  <div class="row">
    @for (product of products(); track product.id) {
    @defer (on viewport; prefetch on immediate) {
    <div class="col-md-4">
      <div class="product-card-grid__item">
        <app-product-card-v2 [cardResume]="{settings: {}, productDetails: product}" class="product-card__box"
          [isSignupFlow]="true" [subscribeAndcustomizeBox]="true" [isFromModal]="true" [isFromShop]="true"
          (farmBoxCard)="subscribed()"></app-product-card-v2>
      </div>
    </div>
    } @placeholder {
    <div class="col-xl-4 col-lg-4 col animated fadeInUp fadeIn mb-3">
      <app-skeleton-product-card></app-skeleton-product-card>
    </div>
    }
    }
  </div>
  }
  } @placeholder (minimum 2s) {
  <div class="loading d-flex justify-content-center mt-3">
    <div class="loader">
      @for (item of [0,0,0,0,0]; track $index) {
      <div class="bg-secondary"></div>
      }
    </div>
  </div>
  }

</section>
